<template>
    <div class="users-table-page weeduc-admin-page text-start p-0">
        <header class="weeduc-admin-page__header">
            <div class="weeduc-admin-page__header-lead">
                <TitlePage
                    :title="$t('admin.users.title')"
                    :subtitle="$t('admin.users.subtitleManage')"
                    :hasMargin="false"
                />
            </div>
            <div class="weeduc-admin-page__header-actions">
                <v-btn
                    variant="tonal"
                    color="primary"
                    rounded="lg"
                    :title="$t('admin.users.importTitle')"
                    :icon="$vuetify.display.xs"
                    class="text-none me-2"
                    @click="$router.push('/dashboard/importar-alunos')"
                >
                    <template v-if="$vuetify.display.xs">
                        <v-icon>mdi-upload</v-icon>
                    </template>
                    <template v-else>
                        <v-icon class="me-1" size="small">mdi-upload</v-icon>
                        {{ $t('admin.users.importStudent') }}
                    </template>
                </v-btn>
                <v-btn
                    variant="flat"
                    color="primary"
                    rounded="lg"
                    :title="$t('admin.users.newUserTitle')"
                    :icon="$vuetify.display.xs"
                    class="text-none edit-courses-new-btn"
                    @click="$router.push('/dashboard/form-usuario')"
                >
                    <template v-if="$vuetify.display.xs">
                        <v-icon>mdi-plus</v-icon>
                    </template>
                    <template v-else>
                        <v-icon class="me-1" size="small">mdi-plus</v-icon>
                        {{ $t('admin.users.newUser') }}
                    </template>
                </v-btn>
            </div>
        </header>

        <div class="weeduc-admin-page__shell">
            <div class="weeduc-admin-page__panel">
                <div class="weeduc-admin-page__toolbar">
                    <v-row align="end" dense>
                        <v-col cols="12" md="5" lg="4">
                            <v-text-field
                                v-model="searchTerm"
                                :label="$t('common.search')"
                                :placeholder="$t('admin.users.searchPlaceholder')"
                                class="inputd weeduc-admin-v-field"
                                variant="outlined"
                                density="compact"
                                hide-details
                                clearable
                                append-inner-icon="mdi-magnify"
                                @update:model-value="onSearch"
                            />
                        </v-col>
                        <v-col cols="12" md="7" lg="8">
                            <div class="weeduc-admin-page__toolbar-field-row">
                                <v-select
                                    v-model="statusFilter"
                                    :items="statusFilterOptions"
                                    item-title="text"
                                    item-value="value"
                                    :label="$t('common.status')"
                                    variant="outlined"
                                    class="inputd weeduc-admin-v-field"
                                    :menu-props="adminSelectMenuProps"
                                    @update:modelValue="getUsersData()"
                                    density="compact"
                                    hide-details
                                />
                                <v-select
                                    v-model="typeFilter"
                                    :items="typeFilterOptions"
                                    item-title="text"
                                    item-value="value"
                                    :label="$t('admin.users.type')"
                                    variant="outlined"
                                    class="inputd weeduc-admin-v-field"
                                    :menu-props="adminSelectMenuProps"
                                    @update:modelValue="getUsersData()"
                                    density="compact"
                                    hide-details
                                />
                            </div>
                        </v-col>
                    </v-row>
                </div>

                <div class="weeduc-admin-page__table-section">
                    <v-table class="custom-table">
                        <thead>
                            <tr>
                                <th class="users-table__name-column">{{ $t('admin.users.name') }}</th>
                                <th class="text-center">{{ $t('admin.users.type') }}</th>

                                <th class="text-center">{{ $t('common.status') }}</th>
                                <th>{{ $t('admin.users.phone') }}</th>
                                <th>{{ $t('admin.users.email') }}</th>
                                <th class="text-center">{{ $t('common.edit') }}</th>
                                <th class="text-center">{{ $t('common.delete') }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="user in filteredUsers" :key="user.id">
                                <td class="users-table__name-column">
                                    {{ user.name }}
                                </td>
                                <td class="text-center">
                                    {{ user.type == 3 ? $t('admin.users.student') : $t('admin.users.manager') }}
                                </td>
                                <td class="text-center">
                                    <v-chip
                                        density="compact"
                                        :color="
                                            user.status == 1
                                                ? 'success'
                                                : 'danger'
                                        "
                                    >
                                        {{
                                            user.status && user.status == 1
                                                ? $t('common.active')
                                                : $t('common.inactive')
                                        }}
                                    </v-chip>
                                </td>
                                <td>
                                    {{
                                        user.phone
                                            ? user.phone
                                            : $t('admin.users.notInformed')
                                    }}
                                </td>
                                <td>{{ user.email }}</td>
                                <td class="text-center">
                                    <v-btn
                                        color="heading"
                                        @click="editUser(user.id)"
                                        icon
                                        variant="text"
                                        :title="$t('admin.users.editUserTitle')"
                                    >
                                        <Icon name="pencil" size="20" />
                                    </v-btn>
                                </td>
                                <td class="text-center">
                                    <v-btn
                                        color="danger"
                                        variant="text"
                                        @click="openDeleteModal(user.id)"
                                        icon
                                        :title="$t('admin.users.deleteUserTitle')"
                                    >
                                        <Icon name="trash" size="20" />
                                    </v-btn>
                                </td>
                            </tr>
                        </tbody>
                    </v-table>
                </div>
                <v-responsive class="weeduc-admin-page__pagination">
                    <v-pagination
                        v-model="currentPage"
                        :length="totalPages"
                        :total-visible="5"
                        :disabled="isLoading"
                        @update:model-value="getUsersData"
                    ></v-pagination>
                </v-responsive>

                <Loader :isActive="!isLoading" />
            </div>
        </div>
        <v-dialog v-model="isDeleteDialogVisible" :max-width="600">
            <v-card class="modal-card">
                <v-card-title>
                    <h3 class="mb-0">
                        {{ $t('admin.users.deleteConfirmTitle') }}
                    </h3>
                </v-card-title>
                <v-card-subtitle>
                    {{ $t('admin.users.deleteConfirmSubtitle') }}
                </v-card-subtitle>
                <v-card-text>
                    <p class="mb-1">
                        {{ $t('admin.users.name') }}: <strong>{{ deletedUser.name }}</strong>
                    </p>
                    <p class="mb-1">
                        {{ $t('admin.users.email') }}: <strong>{{ deletedUser.email }}</strong>
                    </p>
                </v-card-text>
                <v-card-actions>
                    <v-btn
                        class="flex-grow-1 cancel-btn"
                        color="grey-darken-4"
                        variant="tonal"
                        @click="isDeleteDialogVisible = false"
                        >{{ $t('common.cancel') }}</v-btn
                    >
                    <v-btn
                        class="flex-grow-1 text-white"
                        color="danger"
                        variant="flat"
                        :loading="isLoading"
                        :disabled="isLoading"
                        @click="confirmDelete"
                        >{{ $t('common.delete') }}</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import { toast } from 'vue3-toastify';
    import { mapState } from 'vuex';
    import { debounce } from 'lodash';
    import ApiUser from '@/utils/user';
    import Loader from '@/components/Loader/loader.vue';
    import TitlePage from '@/components/Weflix/titlePage.vue';

    export default {
        components: {
            Loader,
            TitlePage,
        },
        data() {
            return {
                usersData: [],
                usersFiltered: [],
                searchTerm: '',
                currentPage: 1,
                itemsPerPage: 10,
                totalPages: 0,
                isDeleteDialogVisible: false,
                deletedUser: null,
                isLoading: false,
                statusFilter: '',
                typeFilter: '',
            };
        },
        computed: {
            ...mapState(['token', 'numberIntensTable', 'websites', 'dark']),

            adminSelectMenuProps() {
                return this.dark
                    ? { contentClass: 'weeduc-admin-select-menu-dark' }
                    : {};
            },

            statusFilterOptions() {
                return [
                    { text: this.$t('common.all'), value: '' },
                    { text: this.$t('common.active'), value: 1 },
                    { text: this.$t('common.inactive'), value: 0 },
                ];
            },

            typeFilterOptions() {
                return [
                    { text: this.$t('common.all'), value: '' },
                    { text: this.$t('admin.users.student'), value: 3 },
                    { text: this.$t('admin.users.manager'), value: 2 },
                ];
            },

            filteredUsers() {
                let filtered = this.usersData;

                if (this.typeFilter !== '') {
                    filtered = filtered.filter(
                        (user) => user.type == this.typeFilter
                    );
                }

                return filtered;
            },
        },
        created() {
            this.getUsersData();
        },
        methods: {
            openDeleteModal(userId) {
                this.deletedUser = this.usersData.find(
                    (user) => user.id === userId
                );
                if (!this.deletedUser) {
                    toast.error(this.$t('admin.users.userNotFound'));
                    return;
                }
                this.isDeleteDialogVisible = true;
            },
            editUser(id) {
                this.$router.push({ path: '/dashboard/form-usuario/' + id });
            },
            async getUsersData() {
                try {
                    this.isLoading = true;
                    const response = await ApiUser.getAllUser(
                        this.token,
                        this.currentPage - 1,
                        this.itemsPerPage,
                        this.searchTerm,
                        this.statusFilter,
                        this.typeFilter
                    );
                    this.usersData = response.content;
                    this.totalPages = response.totalPages;
                } catch (err) {
                    toast.error(this.$t('admin.users.loadError'));
                } finally {
                    this.isLoading = false;
                }
            },
            async confirmDelete() {
                if (this.deletedUser) {
                    try {
                        this.isLoading = true;
                        await ApiUser.EditUser(
                            {
                                ...this.deletedUser,
                                status: 9,
                                id: undefined,
                                photoFinal: undefined,
                                dateInsert: undefined,
                                orderStatus: undefined,
                            },
                            this.token,
                            this.deletedUser.id
                        );
                        toast.success(this.$t('admin.users.deleteSuccess'));
                        this.getUsersData();
                    } catch (error) {
                        toast.error(this.$t('admin.users.deleteError'));
                    } finally {
                        this.isDeleteDialogVisible = false;
                        this.isLoading = false;
                        this.deletedUser = { name: '', email: '' };
                    }
                }
            },
            onSearch: debounce(function () {
                this.getUsersData();
            }, 300),
        },
    };
</script>

<style scoped>
@import url('@/css/weeduc/admin/dashboard-weflix-shell.css');
</style>
